export const SystemName = {
	ShipmentMode: {
		Air: "Air",
		Sea: "Sea",
		Courier: "COU"
	},
	NotificationTransportType: {
		Messaging: "Messaging",
		Email:"Email"
	},
	ScheduleJobType: {
		ShipmentSummaryNotification: "ShipmentSummaryNotification",
		OrderSummaryNotification: "OrderSummaryNotification",
		ContainerSummaryNotification: "ContainerSummaryNotification",
		StatusChangeReport: "StatusChangeReport",
		EstimatedArrivalChangeNotification: "EstimatedArrivalChangeNotification"
	},
	ReportGroup: {
		StatusChangeReport: "StatusChangeReport"
	},
	LocationType: {
		CAFSLocation: "CAFSLocation",
		Port: "Port",
		Address: "Address"
	},
	SettingType: {
		JSON: "Json",
		PortalUISetting:"PortalUISetting"
	},
	DocumentType: {
		Invoice: "Invoice",
		CommercialInvoice: "CommercialInvoice",
		"CustomsEntry/Declaration": "CustomsEntry/Declaration",
		CreditNote: "CreditNote"
	}
} as const;

export const UISettingSystemName = {
	ShipmentAndOrderGrid:"Grid_PortalShipmentAndOrderList",
	OrderGird: "Grid_PortalOrderList",
	ShipmentGrid: "Grid_PortalShipmentList",
	ContainerGrid: "Grid_PortalContainerList",
	TrackPageMapView: "TractPage_MapView",
	TrackPageFilter: "TrackPage_Filter",
	TransportGrid: "Grid_TransportList",
	TransportPageFilter: "TransportPage_Filter",
	ArrivalsCalendarFilter: "ArrivalsCalendarFilter",
	TrackPageShowFilter: "TrackPage_ShowFilter",
	TrackerContainerGrid: "Grid_TrackerContainerDetails",
	TrackerDocumentGrid: "Grid_TrackerDocumentDetails",
	TrackerOrderGrid: "Grid_TrackerOrderDetails",
	TrackerPackingLineGrid: "Grid_TrackerPackingLineDetails"
} as const;

export const NotificationTypeSystemName = {
	ShipmentCreated: "ShipmentCreated",
	ShipmentRequiresApproval: "ShipmentRequiresApproval",
	ShipmentDeparted: "ShipmentDeparted",
	ShipmentArrived:"ShipmentArrived",
	ShipmentArrivedTranshipmentPort: "ShipmentArrivedTranshipmentPort",
	ShipmentDepartedTranshipmentPort: "ShipmentDepartedTranshipmentPort",
	ShipmentArrivalWithinDay: "ShipmentArrivalWithinDay",
	ShipmentReadyForDeliveryAir: "ShipmentReadyForDelivery_AIR",
	ShipmentReadyForDeliveryFCL: "ShipmentReadyForDelivery_FCL",
	ShipmentReadyForDeliveryLCL: "ShipmentReadyForDelivery_LCL",
	ShipmentOnHold: "ShipmentOnHold",
	ShipmentCargoAvailable: "ShipmentCargoAvailable",
	ShipmentSummary: "ShipmentSummary",
	OrderCreated: "OrderCreated",
	OrderCargoReady: "OrderCargoReady",
	OrderInTransit: "OrderInTransit",
	OrderStatusChanged: "OrderStatusChanged",
	OrderMissOriginalReadyDate: "OrderMissOriginalReadyDate",
	OrderCargoReadyWithinDay: "OrderCargoReadyWithinDay",
	OrderSummary:"OrderSummary",
	ContainerCollectedFromWharf: "ContainerCollectedFromWharf",
	ContainerDeliveredToWharf: "ContainerDeliveredToWharf",
	ContainerAtRisk: "ContainerAtRisk",
	ContainerDeparted: "ContainerDeparted",
	ContainerArrived:"ContainerArrived",
	ContainerLoaded: "ContainerLoaded",
	ContainerAvailable: "ContainerAvailable",
	ContainerDehired: "ContainerDehired",
	ContainerSummary: "ContainerSummary",
	ContainerCustomsClearance: "ContainerCustomsClearance",
	TransportJobBookingRequested: "TransportJobBookingRequested",
	DeliveryBooked: "DeliveryBooked",
	DeliveryOccurredAir: "DeliveryOccurred_AIR",
	DeliveryOccurredFCL: "DeliveryOccurred_FCL",
	DeliveryOccurredLCL: "DeliveryOccurred_LCL",
	DeliveryMissIntoStoreDate: "DeliveryMissIntoStoreDate",
	CustomClearanceConcluded: "CustomClearanceConcluded",
	InvoicePaid: "InvoicePaid",
	InvoiceOverdue: "InvoiceOverdue",
	StatementAvailable: "StatementAvailable",
	BillOfLading: "BillofLading",
	CommercialInvoice: "CommercialInvoice",
	PackingList: "PackingList",
	PackingDeclaration: "PackingDeclaration",
	CertificateOfOrigin: "CertificateofOrigin",
	CustomsEntryDeclaration: "CustomsEntry/Declaration",
	ProofOfDelivery: "ProofOfDelivery",
	StatusChangeReport: "StatusChangeReport",
	EarlyEstimatedArrivalChangeNotification: "EarlyEstimatedArrivalChangeNotification",
	LateEstimatedArrivalChangeNotification: "LateEstimatedArrivalChangeNotification"
} as const;
